module.exports = __webpack_public_path__ + "img/9788954636797.bcad45ae.jpg";